module.exports = __webpack_public_path__ + "img/liturghier-1729-pagina-de-titlu-big.a71a3b8f.jpg";